<div
  class="selected-display"
  [ngClass]="{ 'readonly': readonly }"
  (click)="activate()">
  @if (!multiSelectionMode) {
    <div
      [title]="selectedDisplayHints?.[0] ?? ''"
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div>
        {{ selectedDisplays?.[0] }}
      </div>
      @if (!readonly) {
        <i
        class="icon icon-caret_down display-icon"></i>
      }
    </div>
  }
  @if (multiSelectionMode) {
    <div
      class="display-pills-container">
      @if (selectedDisplays?.length !== 0) {
        <div
          fxLayout="row {{flowMode ? 'wrap' : ''}}"
          fxLayoutAlign="left center">
          @for (selectedDisplay of selectedDisplays; track selectedDisplay; let index = $index) {
            <div>
              <div
                class="display-pill"
                [ngClass]="{'inactive': selectedDisplayActive?.[index] !== true}"
                [title]="selectedDisplayHints?.[index]">
                {{ selectedDisplay }}
              </div>
            </div>
          }
        </div>
      }
      @if (hasBusinessUnits && !(selectedDisplays?.length !== 0)) {
        <div
          class="display-pill">
          {{ 'COMMUNICATIONS.BUTTONS.SELECT' | translate }}
        </div>
      }
    </div>
  }
</div>
